import { render, staticRenderFns } from "./scaq.vue?vue&type=template&id=85cb31aa&scoped=true&"
import script from "./scaq.vue?vue&type=script&lang=js&"
export * from "./scaq.vue?vue&type=script&lang=js&"
import style0 from "./scaq.vue?vue&type=style&index=0&id=85cb31aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb31aa",
  null
  
)

export default component.exports